import { combineReducers } from 'redux';
import detailPrices from './index';

const appReducer = combineReducers({
  detailPrices: detailPrices,
});

export default appReducer;
